$( document ).ready(function() {
    $('.gravityform input, .gravityform select').each(function( index ) {
        if($(this).val()) {
            $(this).closest('.gfield, span[class^="ginput_"]').addClass('__typed');
        }
    });
});

$(".gravityform input, .gravityform select").change( function() {
    if($(this).val()) {
        $(this).closest('.gfield, span[class^="ginput_"]').addClass('__typed');
    } else {
        $(this).closest('.gfield, span[class^="ginput_"]').removeClass('__typed');
    }
});